import { Link } from "react-router-dom";
import { exitReadiness } from "../data/content";

export default function PrimaryPractice() {
  const s = exitReadiness;
  return (
    <section
      id="exit-readiness"
      data-testid="primary-practice-section"
      className="relative bg-ink text-paper border-b border-paper/10 overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          {/* LEFT — image */}
          <div className="col-span-12 lg:col-span-5 reveal">
            <div className="relative">
              <div className="absolute -bottom-3 -right-3 w-full h-full bg-mustard -z-0 hidden md:block" />
              <div className="relative z-10 overflow-hidden">
                <img
                  src={s.image}
                  alt="Founder's exit readiness"
                  className="w-full aspect-[4/5] object-cover img-editorial"
                  data-testid="primary-practice-image"
                />
              </div>
            </div>

            <div className="relative z-10 mt-6 flex flex-wrap gap-2">
              {s.tags.map((t) => (
                <span
                  key={t}
                  className="text-[11px] tracking-wider uppercase border border-paper/25 px-3 py-1.5 text-paper/85"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {/* RIGHT — content */}
          <div className="col-span-12 lg:col-span-7 lg:pl-6">
            <div className="flex items-center gap-3 reveal">
              <span className="w-1.5 h-1.5 bg-mustard" />
              <span className="overline text-mustard">Primary practice — 02</span>
            </div>

            <h2
              data-testid="primary-practice-heading"
              className="mt-6 serif text-4xl sm:text-5xl md:text-6xl lg:text-[72px] font-light tracking-tight leading-[0.98] text-paper reveal"
            >
              Founder&apos;s
              <br />
              Exit Readiness
            </h2>

            <p
              className="mt-6 text-lg md:text-xl text-paper/80 max-w-2xl reveal"
              data-testid="primary-practice-tagline"
            >
              {s.tagline}
            </p>

            <div className="mt-10 pt-8 border-t border-paper/15 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-7 reveal">
              <div>
                <div className="overline text-paper/60 mb-2">Situation</div>
                <p className="text-sm md:text-base leading-relaxed text-paper/85">
                  {s.situation}
                </p>
              </div>
              <div>
                <div className="overline text-mustard mb-2">Our response</div>
                <p className="text-sm md:text-base leading-relaxed text-paper">
                  {s.response}
                </p>
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-paper/15 reveal">
              <div className="overline text-paper/60 mb-5">Outcomes</div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-2.5 gap-x-8">
                {s.outcomes.map((o) => (
                  <li
                    key={o}
                    className="flex items-baseline gap-3 text-sm md:text-base text-paper/90"
                  >
                    <span className="text-mustard">—</span>
                    <span>{o}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-5 gap-x-6 gap-y-4 reveal">
              <Spec k="Horizon" v="12–36 mo" />
              <Spec k="Diagnostic" v="4–8 wks" />
              <Spec k="Embedded" v="6–18 mo" />
              <Spec k="Fee" v="Fixed monthly" />
              <Spec k="Capacity" v="One client" />
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-4 reveal">
              <a
                href="https://calendly.com/sarangandhi1/30min"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="primary-practice-cta-calendly"
                className="inline-flex items-center justify-center gap-3 bg-mustard text-ink px-7 py-4 text-sm tracking-wide hover:bg-paper hover:text-ink transition-colors duration-300 group"
              >
                Book a 30-minute call
                <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
              </a>
              <Link
                to={`/services/${s.slug}`}
                data-testid="primary-practice-readmore"
                className="group inline-flex items-center gap-3 text-sm tracking-wide text-paper hover:text-mustard transition-colors duration-300 px-2 py-4"
              >
                <span className="link-line">How it works</span>
                <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Spec({ k, v }) {
  return (
    <div>
      <dt className="overline text-paper/60">{k}</dt>
      <dd className="serif text-base md:text-lg text-paper mt-1 font-light">{v}</dd>
    </div>
  );
}
